import React from 'react';
import * as Devices from '../../../modules/devices';
import SVGIcon, { SVGIcons } from '../../shared/svgIcon';
import LinkText from '../../shared/linkText';
import useTxRequest from '../../../modules/dialogs/transfer/useTxRequest';

const Item = (device: Devices.PKey): JSX.Element => {
  const {clearDevice} = useTxRequest();
  const pkey = Devices.getPK(device);
  const id = `dg-tx-req-list-item-${pkey}`;
  const contentClassName ='item_content ';
  return (
    <div id={id} key={id} className="kam_listitem">
      <div className={contentClassName}>
        <span className="icon">
          <SVGIcon name={SVGIcons.Flag} fill="red" width="100%" height="100%" />
        </span>
        <div className="info">
          <span className="title">
            {pkey}
          </span>
        </div>
      </div>
      <LinkText
        onClick={() => clearDevice(device)}
        className="item_clear"
        content={<SVGIcon name={SVGIcons.Dismiss} />}
      />
    </div>
  );
};


const List: React.FC = () => {
  const { tx } = useTxRequest();
  return (
    <div className="kam_list">
      {tx.devices.map((d) => (
        <Item key={`txrequest_item-${Devices.getPK(d)}`} {...d} />
      ))}
    </div>
  );
};

export default List;
